import React from "react";
import ReactTooltip from "react-tooltip";

const ReactTooltipWrapper = () => {
  return <ReactTooltip className={'app-tooltip'} place='bottom'  />
}

export default ReactTooltipWrapper;

